import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { theme, VStack } from '@sweetgreen/garnish';

import type { AccountMenuVariant } from '../../AccountMenu.types';

export const AccountSection = ({ variant, children }: AccountMenuProps) => {
  const style =
    variant === 'STANDALONE' ? styles.hardDivider : styles.softDivider;

  return (
    <VStack style={style} customSpacing={0}>
      {children}
    </VStack>
  );
};

type AccountMenuProps = {
  readonly variant: AccountMenuVariant;
} & ViewProps;

const styles = StyleSheet.create({
  softDivider: {
    width: '100%',
    borderTopWidth: 1,
    borderTopColor: theme.colors.LIGHT,
    marginTop: theme.spacing.medium,
    paddingTop: theme.spacing.medium,
  },
  hardDivider: {
    width: '100%',
    borderTopWidth: 1,
    borderTopColor: theme.colors.DARK_KALE,
    marginTop: theme.spacing.large,
    paddingTop: theme.spacing.large,
  },
});
